import { FuseNavigationItem } from '@fuse/components/navigation';
import { Roles } from 'app/core/Enums/Roles';

export const defaultNavigation: FuseNavigationItem[] = [
  {
    key: [Roles.Admin, Roles.Monitoring, Roles.Operator],
    id: 'apps',
    translate: 'apps',
    title: 'Приложении',
    // subtitle: 'Custom made application designs',
    type: 'group',
    icon: 'heroicons_outline:home',
    children: [
      {
        id: 'vacancy',
        translate: 'vacancy',
        title: 'Вакансии',
        type: 'basic',
        icon: 'vacancy',
        link: 'apps/vacancy/list',
      },
      {
        id: 'vacancy_open',
        translate: 'vacancy.open_list',
        title: 'Вакансии',
        type: 'basic',
        icon: 'vacancy-list',
        link: 'apps/vacancy/open-list',
      },
    ],
  },
  {
    key: [Roles.Admin, Roles.Monitoring, Roles.Operator],
    id: 'applications',
    type: 'group',
    translate: 'applications_group',
    title: 'application group',
    icon: 'mat_solid:featured_play_list',
    children: [
      {
        id: 'application_list',
        translate: 'application.list',
        title: 'Заявки',
        type: 'basic',
        icon: 'applicant',
        link: 'apps/application',
      },
      {
        id: 'selected_applications',
        translate: 'selected_applications',
        title: 'selected applications',
        type: 'basic',
        icon: 'selected',
        link: 'apps/selected-applications',
      },
      {
        id: 'archives',
        translate: 'archives',
        title: 'Archives',
        type: 'basic',
        icon: 'archive',
        link: 'apps/archives',
      },
      {
        id: 'statistics',
        translate: 'statistics.title',
        title: 'Statistika',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar',
        link: 'apps/statistics',
      },
      // {
      //   id: 'reserved_applications',
      //   translate: 'reserved_applications',
      //   title: 'reserved applications',
      //   type: 'basic',
      //   icon: 'reserved',
      //   link: 'apps/reserved-applications',
      // },
    ],
  },
  {
    key: [Roles.Admin],
    id: 'admin',
    translate: 'admin',
    title: 'Администрирование',
    // subtitle: 'Custom made application designs',
    type: 'group',
    icon: 'heroicons_outline:cog',
    children: [
      {
        id: 'users',
        translate: 'users',
        title: 'Пользователи',
        type: 'basic',
        icon: 'users-title',
        link: 'admin/account/users',
      },
      // {
      //   id: 'users',
      //   translate: 'users',
      //   title: 'Пользователи',
      //   type: 'basic',
      //   icon: 'users-title',
      //   link: 'admin/account/users2',
      // },
      {
        id: 'translations',
        translate: 'translations',
        title: 'Переводи интерфейса',
        type: 'basic',
        icon: 'interface-lang',
        link: 'admin/translations',
      },
      {
        id: 'sps',
        translate: 'sps',
        title: 'Справочник',
        type: 'basic',
        icon: 'info-icon',
        link: 'admin/sps',
      },

      // {
      //     id: 'profile',
      //     translate: 'profile',
      //     title: 'Профиль',
      //     type: 'basic',
      //     icon: 'mat_solid:account_circle',
      //     link: 'pages/profile',
      // }
    ],
  },
];
